module.exports = __webpack_public_path__ + "img/404.415935a1.png";